export const EVENTO_ABRIR_CENTRO_AYUDA = 'senciyo:abrir-centro-ayuda';

export interface ContextoCentroAyuda {
  busqueda?: string;
}

export const abrirCentroAyuda = (contexto: ContextoCentroAyuda = {}): void => {
  window.dispatchEvent(new CustomEvent<ContextoCentroAyuda>(EVENTO_ABRIR_CENTRO_AYUDA, { detail: contexto }));
};
